// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * List of response messages from server.
 * @export
 * @interface IResponseMessage
 */
export interface IResponseMessage {
    /**
     * 
     * @type {string}
     * @memberof IResponseMessage
     */
    result_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IResponseMessage
     */
    message_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IResponseMessage
     */
    transaction_status?: string | null;
}

/**
 * Check if a given object implements the IResponseMessage interface.
 */
export function instanceOfIResponseMessage(value: object): value is IResponseMessage {
    return true;
}

export function IResponseMessageFromJSON(json: any): IResponseMessage {
    return IResponseMessageFromJSONTyped(json, false);
}

export function IResponseMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): IResponseMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'result_code': json['resultCode'] == null ? undefined : json['resultCode'],
        'message_text': json['messageText'] == null ? undefined : json['messageText'],
        'transaction_status': json['transactionStatus'] == null ? undefined : json['transactionStatus'],
    };
}

export function IResponseMessageToJSON(json: any): IResponseMessage {
    return IResponseMessageToJSONTyped(json, false);
}

export function IResponseMessageToJSONTyped(value?: IResponseMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resultCode': value['result_code'],
        'messageText': value['message_text'],
        'transactionStatus': value['transaction_status'],
    };
}

